/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateJobPositionDto
 */
export interface CreateUpdateJobPositionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateJobPositionDto
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateJobPositionDto
     */
    harmfulFactorsIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateJobPositionDto
     */
    active?: boolean | null;
}

/**
 * Check if a given object implements the CreateUpdateJobPositionDto interface.
 */
export function instanceOfCreateUpdateJobPositionDto(value: object): value is CreateUpdateJobPositionDto {
    return true;
}

export function CreateUpdateJobPositionDtoFromJSON(json: any): CreateUpdateJobPositionDto {
    return CreateUpdateJobPositionDtoFromJSONTyped(json, false);
}

export function CreateUpdateJobPositionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateJobPositionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'harmfulFactorsIds': json['harmfulFactorsIds'] == null ? undefined : json['harmfulFactorsIds'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function CreateUpdateJobPositionDtoToJSON(value?: CreateUpdateJobPositionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'harmfulFactorsIds': value['harmfulFactorsIds'],
        'active': value['active'],
    };
}

